import { styled } from "@mui/material/styles";

export const ImgFileInput = styled("input")({
  display: "none",
});
